import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { UsageTypeResponse } from '@/types/apps/usage-type.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface UsageTypeGraphQLServiceInterface {}

type UsageTypeGraphQLListResponse = GqlListResponse<UsageTypeResponse>;

export class UsageTypeGraphQLService
    extends BaseService
    implements UsageTypeGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'usageType';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
        };
    }

    public async index(query: string): Promise<UsageTypeGraphQLListResponse> {
        return this.fetchGqlList<UsageTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('usageType', {
            userId: this.getQueryById(),
        });
    }
}
